// '[\w\.%\+\-\']+'.freeze
//   self.domain_head_regex = '(?:[A-Z0-9\-]+\.)+'.freeze
//   self.domain_tld_regex  = "(?:[a-zA-Z]{2,})".freeze
//   self.email_regex       = /\A#{email_name_regex}@#{domain_head_regex}#{domain_tld_regex}\z/i

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;